/**
 *
 * OCRTextPageRegionLineWord
 *
 */

import * as React from 'react';
import clsx from 'clsx';
import { useMemo } from 'react';
import { OCRWord, ocrBoundingBoxToPosition } from 'lib/api/ocrResult';
import store from 'store';

// decorate
import { decorate, Decorate } from './decorate';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface OCRTextPageRegionLineWord {
  scale: number;
  word: OCRWord;
  visible: boolean;
  outlined: boolean;
  disableText: boolean;
  parentTop: number;
  parentLeft: number;
}

const OCRTextPageRegionLineWord: React.FC<OCRTextPageRegionLineWord & Decorate> = (props) => {
  const { classes, scale, word, visible, outlined, disableText, parentTop, parentLeft } = props;

  const { top, left, width, height } = useMemo(() => ocrBoundingBoxToPosition(word.BoundingBox), [
    word.BoundingBox.Rectangle,
  ]);

  // adjust the font size and positioning so that it fits the container
  const fontHeight = height * scale;
  const textWidth = useMemo(() => {
    const context = document.createElement('canvas').getContext('2d');
    if (!context) {
      return 0;
    }
    context.font = `${fontHeight}px sans-serif`;
    const textWidth = context.measureText(word.Text).width;
    return textWidth;
  }, [word.Text, fontHeight]);

  const getElementData = (element : any)=> {
    const elementPage = element.parentElement.parentElement.parentElement.parentElement.parentElement;
    navigator.clipboard.writeText(element.textContent);
    store.set('LassoValue', element.textContent);
    store.set('LassoTop', top * scale);
    store.set('LassoLeft', left * scale) ;
    store.set('LassoHeight', height * scale);
    store.set('LassoWidth', width * scale);
    store.set('PageNumber', elementPage.id.charAt(elementPage.id.length - 1) - 1);
    store.set('NoValue', false);
    toast.info(`Copied: ${element.textContent}`, { 
      theme: 'light' , 
      position: 'bottom-center',
      autoClose: 3000 
    });
  }

  return (
    <span
      onClick={(e)=> getElementData(e.target)}
      className={clsx(
        classes.root,
        !disableText && classes.textCursor,
        !visible && classes.transparent,
        outlined && classes.outlined,
      )}
      style={{
        top: (top - parentTop) * scale,
        left: (left - parentLeft) * scale,
        width: width * scale,
        height: height * scale,
        fontSize: fontHeight,
        letterSpacing: (width * scale - textWidth) / word.Text.length,
        fontWeight: word.Bold ? 'bold' : undefined,
        textDecoration: word.Underlined ? 'underline' : undefined,
        fontStyle: word.Italic ? 'italic' : undefined,
      }}
    >
      {!disableText && word.Text}
    </span>
  );
};

const ComposedOCRTextPageRegionLineWord = decorate(OCRTextPageRegionLineWord);
export { ComposedOCRTextPageRegionLineWord as OCRTextPageRegionLineWord };
